import { ICON_COLLAPSED, ICON_EXPANDED } from "@/src/design_system/shared/constants/expand";
import { DSIconName } from "@/src/design_system/primitives/icon/types/iconName.generated";

export const getExpandIcon = (expanded: boolean): DSIconName => (expanded ? ICON_EXPANDED : ICON_COLLAPSED);
